import Frame from "../Frames/Basic"
import SignUpForm from "./components/SignUpForm"

export default function Register(){

    return <Frame center>

        <SignUpForm />
        
    </Frame>
}